module.exports = __webpack_public_path__ + "static/media/useradd.25f91b21.svg";